<template>
  <div class="car-archive-details">
    <div class="car-archive-details-content">
      <!-- 车辆信息 -->
      <div class="car">
        <div class="title">车辆信息</div>
        <div class="row">
          <div v-for="(i, index) in carInfo" :key="index">
            <span>{{ i.name }}</span>
            <span>{{ i.value }}</span>
          </div>
        </div>
      </div>
      <div class="car-img">
        <div class="img" v-for="(i, index) in imgUrl" :key="index">
          <span v-if="i.damageFlag === 1" class="red-warn">质损</span>
          <el-image
            :src="i.ossUrl"
            @click="handlePreviewOpen(i)"
          />
        </div>
      </div>
    </div>

    <!-- 查看图片 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      class="look-img"
    >
      <el-image
        :src="itemImgUrl.ossUrl"
        :preview-src-list="[itemImgUrl.ossUrl]"
      />
      <div :class="`sign${itemImgUrl.damageFlag}`">{{ itemImgUrl.damageFlag === 1?'质损':'正常'}}</div>
      <el-input
        type="textarea"
        resize="none"
        class="white"
        v-model="itemImgUrl.damageRemark"
        placeholder="请输入"
        disabled
        clearable
      ></el-input>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyNetTitle, formaTimeToAllSecond } from "common/js/util";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {

  data() {
    return {
      carInfo: [
        {name: '车架号：', value: ''},
        {name: '作业类型：', value: ''},
        {name: '采集员：', value: ''},
        {name: '车辆情况：', value: ''},
        {name: '图像数量：', value: ''},
        {name: '采集时间：', value: ''}
      ],
      imgUrl: [],
      itemImgUrl: {
        damageFlag: 0,
        damageRemark: '',
        ossUrl: ''
      },
      dialogVisible: false
    }
  },

  created() {
    modifyNetTitle('车辆影像档案详情')
    this.initDetails()
  },

  methods: {
    initDetails() {
      const id = Number(this.$route.query.id)
      SmartVehicleInspection.getCarArchiveDetails(id).then(res => {
        if (res.success) {
          const { vin, vehicleStatus, jobType, collectorName, photos, submitTime } = res.result
          this.carInfo = [
            {name: '车架号：', value: vin},
            {name: '作业类型：', value: jobType === 1?'接收检验':'移交检验'},
            {name: '采集员：', value: collectorName},
            {name: '车辆情况：', value: vehicleStatus === 0?'正常':'有质损'},
            {name: '图像数量：', value: photos.length},
            {name: '采集时间：', value: submitTime ? formaTimeToAllSecond(submitTime) : ''},
          ]
          this.imgUrl = photos
        }
      })
    },

    handlePreviewOpen(i) {
      this.itemImgUrl = i
      this.dialogVisible = true
    },
    
    closeDialog() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang='scss' scoped>
.car-archive-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .car-archive-details-content {
    height: 100%;
    padding: 24px 30px;
    background: #fff;
    border-radius: 8px;
    .title {
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
    }
    .car {
      width: 100%;
      border-bottom: 1px solid #eee;
      padding-bottom: 24px;
      margin-bottom: 24px;
      .row {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        row-gap: 24px;
        column-gap: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    .car-img {
      display: grid;
      grid-template-columns: repeat(auto-fit, 150px);
      row-gap: 24px;
      column-gap: 24px;
      .img {
        width: 150px;
        height: 150px;
        position: relative;
        .el-image {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
        .red-warn {
          position: absolute;
          top: 0px;
          right: 0px;
          color: #F76F6B;
          background: #FDE1E1;
          font-size: 12px;
          padding: 2px 4px;
          z-index: 9;
          border: 1px solid salmon;
          border-radius: 2px 0px 2px 2px;
        }
      }
    }
  }
  ::v-deep.el-image-viewer__close {
    color: white;
  }
  .look-img {
    ::v-deep.el-dialog .el-dialog__body {
      padding-top: 16px;
    }
    .sign0,
    .sign1 {
      width: 36px;
      font-size: 12px;
      padding: 2px 0px;
      border-radius: 2px;
      text-align: center;
      margin-top: 10px;
    }
    .sign0 {
      color: #82CC8B;
      background: #D9F5D6;
      border: 1px solid #ACE7A5;
    }
    .sign1 {
      color: #F76F6B;
      background: #FDE1E1;
      border: 1px solid salmon;
    }
    .el-textarea {
      height: 64px;
      margin-top: 10px;
      .el-textarea__inner {
        min-height: 64px!important;
      }
    }
    ::v-deep.el-textarea.is-disabled .el-textarea__inner {
      background-color: white;
      color: #666666;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
